import { format } from "date-fns";

export function fDate(date: any) {
    return format(new Date(date), 'dd/MM/yyyy');
}